import classNames from 'classnames';
import type { NamePath } from 'rc-field-form/es/interface';
import React from 'react';

import styles from './CheckboxCell.module.scss';
import { EditableCheckboxField } from './EditableCheckboxField';

export type CheckboxCellProps = {
  disabled?: boolean;
  grayed?: boolean;
  name: NamePath;
  className?: string;
};

export const CheckboxCell: React.FC<CheckboxCellProps> = React.memo(
  ({ disabled = false, grayed = false, name, className }) => {
    return (
      <div
        className={classNames(styles.checkboxCell, className, {
          [styles.disabled]: grayed,
        })}
      >
        <EditableCheckboxField name={name} disabled={disabled} />
      </div>
    );
  }
);
